import { useState, useEffect } from 'react';
import CustomerPortfolioService from '../CustomerPortfolio/service';
import { toast } from 'react-toastify';

export const useGetCustomerPortfolios = () => {
  const [customerPortfolios, setCustomerPortfolios] = useState([]);

  useEffect(() => {
    CustomerPortfolioService.getWithoutPagination(false, false)
      .then((response) => {
        const data = response.data.data.content.map((item) => ({
          name: item.name,
          id: item.id
        }));
        setCustomerPortfolios(data);
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.message ||
            err.message ||
            'Erro ao buscar categoria dos clientes'
        );
      });
  }, []);

  return { customerPortfolios };
};
